var trackError = require('trackError')

module.exports = Em.Route.extend({
    userOrganizations: Em.inject.service(),

    beforeModel: function(transition) {
        var queryParams = transition.queryParams || {}

        // Store OAuth callback parameters
        this.set('code', queryParams.code)
        this.set('state', queryParams.state)
        this.set('error', queryParams.error)
        this.set('errorDescription', queryParams.error_description)
    },

    model: function() {
        var code = this.get('code')
        var state = this.get('state')
        var error = this.get('error')
        var errorDescription = this.get('errorDescription')
        var orgUrl = this.get('orgUrl')

        // If there's an OAuth error, handle it
        if (error) {
            trackError('Shine OAuth error: ' + error + ' - ' + errorDescription)
            return Ember.RSVP.resolve({
                error: error,
                errorDescription: errorDescription,
                orgUrl: orgUrl
            })
        }

        // If no code, something went wrong
        if (!code) {
            trackError('Shine OAuth callback missing authorization code')
            return Ember.RSVP.resolve({
                error: 'missing_code',
                errorDescription: 'Authorization code not provided',
                orgUrl: orgUrl
            })
        }

        // Return success
        return Ember.RSVP.resolve({
            success: true,
            code: code,
            state: state,
            orgUrl: orgUrl
        })
    },

    afterModel: function(model) {
        var self = this
        var orgName = this.get('userOrganizations.lastOrganizationUrl')
        var redirectUrl

        if (model.success) {
            var code = this.get('code')
            var state = this.get('state')
            redirectUrl = '/' + orgName + '/dashboard?code=' + code + '&state=' + state
        } else {
            redirectUrl = '/' + orgName + '/dashboard?state=error'
        }

        self.transitionTo(redirectUrl)
    }
})
